import {
	Mesh,
	MeshBasicMaterial,
	PlaneGeometry,
	PositionalAudio,
	Audio,
	AudioLoader,
	AudioListener
} from 'three'

import {PositionalAudioHelper} from "three/examples/jsm/helpers/PositionalAudioHelper";
import { useUserinfo } from '@/stores/userinfo'
import {toRef} from "vue";

const userinfo = useUserinfo()
const userInfoRef = toRef(userinfo)

/*
 * Audio Resources
 * */

export class AudioManager {
	constructor(scene,camera) {
		this.init(scene,camera)
	}
	
   bgListener = null;
   bgAudio = null;
   bgAudioLoader = null;
   
   flyListener = null;
   flyAudio = null;
   flyAudioLoader = null;
   
   
   carListener = null;
   carAudio = null;
   carAudioLoader = null;
   
   
   downListener = null;
   downAudio = null;
   downAudioLoader = null;
   
   
   
  init(scene,camera) {
    this.scene = scene
	this.camera = camera
	
	// 非位置音频可用于不考虑位置的背景音乐
	// 创建一个监听者
	this.flyListener = new AudioListener();
	// camera.add( listener );
	// 创建一个非位置音频对象  用来控制播放
	this.flyAudio = new Audio(this.flyListener);
	// 创建一个音频加载器对象
	this.flyAudioLoader = new AudioLoader();
	// 加载音频文件，返回一个音频缓冲区对象作为回调函数参数
	this.flyAudioLoader.load(process.env.BASE_URL +'audio/flying.mp3', buffer => {
		this.flyAudio.setBuffer(buffer);
		this.bgAudio.setLoop(false); //是否循环
		this.bgAudio.setVolume(0.6); //音量
	})
	
	this.downListener = new AudioListener();
	// camera.add( listener );
	// 创建一个非位置音频对象  用来控制播放
	this.downAudio = new Audio(this.downListener);
	// 创建一个音频加载器对象
	this.downAudioLoader = new AudioLoader();
	// 加载音频文件，返回一个音频缓冲区对象作为回调函数参数
	this.downAudioLoader.load(process.env.BASE_URL +'audio/pressdown.mp3', buffer => {
		this.downAudio.setBuffer(buffer);
		this.downAudio.setLoop(false); //是否循环
		this.downAudio.setVolume(1); //音量
	})
	
	
	this.bgListener = new AudioListener();
	// camera.add( listener );
	// 创建一个非位置音频对象  用来控制播放
	this.bgAudio = new Audio(this.bgListener);
	// 创建一个音频加载器对象
	this.bgAudioLoader = new AudioLoader();
	// 加载音频文件，返回一个音频缓冲区对象作为回调函数参数
	this.bgAudioLoader.load(process.env.BASE_URL +'audio/music_island.m4a', buffer => {
		this.bgAudio.setBuffer(buffer);
		this.bgAudio.setLoop(true); //是否循环
		this.bgAudio.setVolume(0.3); //音量
	})
	
	}
	
	// qita(){
	// 	// 用来定位音源的网格模型
	// 	var audioMesh = new THREE.Mesh(geometry, material);
	// 	// 设置网格模型的位置，相当于设置音源的位置
	// 	audioMesh.position.set(0, 0, 300);
	// 	scene.add(audioMesh);
		
	// 	// 创建一个虚拟的监听者
	// 	var listener = new THREE.AudioListener();
	// 	// 监听者绑定到相机对象
	// 	camera.add(listener);
	// 	// 创建一个位置音频对象,监听者作为参数,音频和监听者关联。
	// 	var PosAudio = new THREE.PositionalAudio(listener);
	// 	//音源绑定到一个网格模型上
	// 	audioMesh.add(PosAudio);
	// 	// 创建一个音频加载器
	// 	var audioLoader = new THREE.AudioLoader();
	// 	// 加载音频文件，返回一个音频缓冲区对象作为回调函数参数
	// 	audioLoader.load(process.env.BASE_URL +'audio/steamwhistle.mp3', function(AudioBuffer) {
	// 	  // console.log(buffer);
	// 	  // 音频缓冲区对象关联到音频对象audio
	// 	  PosAudio.setBuffer(AudioBuffer);
	// 	  PosAudio.setVolume(0.9); //音量
	// 	  PosAudio.setRefDistance(200); //参数值越大,声音越大
	// 	  PosAudio.play(); //播放
	// 	});
	// }
	
	createAudio() {
		console.log(this.bgAudiobuffer)
		
		this.audio_mesh = new Mesh(new PlaneGeometry(10, 10), new MeshBasicMaterial({color: 0xff0000}));
		this.audio_mesh.position.set(410, 0, 40);
		this.audio_mesh.visible = false;
		this.scene.add(this.audio_mesh)
		this.carListener = new AudioListener();

		this.camera.add(this.carListener);
		this.carAudio= new PositionalAudio(this.carListener);
		this.audio_mesh.add(this.carAudio);
		
		// 创建一个音频加载器
		this.carAudioLoader = new AudioLoader();
		this.carAudioLoader.load(process.env.BASE_URL +'audio/steamwhistle.mp3', buffer => {
			this.carAudio.setBuffer(buffer);
			this.carAudio.setLoop(true); //是否循环
			this.carAudio.setVolume(0.9); //音量
			this.carAudio.setDirectionalCone(180, 10, 0.5);
			this.carAudio.setRefDistance(10); //参数值越大,声音越大
			this.carAudio.play(); //播放
		})
		
	// 	// const helper = new PositionalAudioHelper(positional_audio)
	// 	const buffer = new AudioLoader().load(process.env.BASE_URL +'audio/我记得.m4a');
	
	// 	this.positional_audio.setBuffer(buffer);
		
	// 	this.positional_audio.setVolume(1);
	// 	// positional_audio.setRefDistance(2);
	// 	// positional_audio.setDirectionalCone(180, 230, 0.5);
	// 	// positional_audio.setLoop(true);
	// 	// positional_audio.add(helper);
	// 	// this.positional_audio?.play();
		
	// 	console.log(this.positional_audio)

		// return Promise.resolve();
	}
	playflyAudio(){
		if (userInfoRef.value.openSound === true){
			this.flyAudio.play();
		}
	}
	stopflyAudio(){
		this.flyAudio.pause();
	}
	playbgAudio(){
		if (userInfoRef.value.openSound === true) {
			this.bgAudio.play();
		}
	}
	stopbgAudio(){
		this.bgAudio.stop();
	}
	playdownAudio(){
		if (userInfoRef.value.openSound === true){
			this.downAudio.stop();
			this.downAudio.play();
		}
	}
	
	stopcarAudio(){
		this.carAudio.stop();
	}
	playcarAudio(){
		if (userInfoRef.value.openSound === true){
			this.carAudio.play();
		}
	}
	
	stopdownAudio(){
		this.downAudio.pause();
	}
	stopAllAuio(){
		this.stopbgAudio()
		this.stopcarAudio()
		this.stopflyAudio()
	}
	
	playAllAuio(){
		
		// console.log(userInfoRef.value.openSound)
		this.playbgAudio()
		this.playcarAudio()
	}
	playAudio() {
		
		//this.bgAudio.play(); //play播放、stop停止、pause暂停
		// this.positional_audio?.play();
		// console.log("-----")
		// console.log(this.positional_audio)
	}
}
